import React from 'react';
import styled from 'styled-components/macro';
import _ from 'lodash';

import { TextRegularItalics } from '@components/elements/TextStyles';
import BasicTable from '@components/composite/BasicTable/BasicTable';
import IconCart from '@components/icons/IconCart';
import MenuButton from '@components/controls/MenuButton/MenuButton';
import TrashIcon from '@components/icons/trash.icon';

type PropsI = {
  products: any[];
  cart: any[];
  updateCart: any;
  debug?: boolean;
};

const tableFields = [
  { value: 'delete', label: '', width: 50 },
  { value: 'name', label: 'Product Name', width: 250 },
  { value: 'catalogNumber', label: 'Cat. No.', width: 100 },
  { value: 'credits', label: 'Unit Credits', width: 100 },
  { value: 'price', label: 'Unit Price', width: 100 },
  { value: 'quantity', label: 'Unit Qty', width: 100 },
  { value: 'totalCredits', label: 'Total Credits', width: 100 },
  { value: 'totalCost', label: 'Total Cost', width: 100 },
]

const getTableRows = (cart, products, handleDelete) => {
  let rows = [];
  for (const cartItem of Object.keys(cart)) {
    const productInfo = products.find((item) => cartItem === item.catalogNumber);
    let row = {};
    row['delete'] =
      <MenuButton
        icon={<TrashIcon />}
        onClick={() => handleDelete(productInfo.catalogNumber)}
        spacing={'horizontal'}
        text={'Delete Item'}
        tooltipPlacement={'bottom-end'}
      />
    for (const field of tableFields) {
      if (!['delete', 'price', 'quantity', 'totalCredits', 'totalCost'].includes(field.value)) {
        row[field.value] = _.get(productInfo, field.value, '');
      } else if (field.value === 'price') {
        row[field.value] = (productInfo.price/100).toString() + ' ' + productInfo.currency;
      } else if (field.value === 'quantity') {
        row[field.value] = cart[cartItem];
      } else if (field.value === 'totalCredits') {
        row[field.value] = cart[cartItem] * productInfo.credits;
      } else if (field.value === 'totalCost') {
        row[field.value] = (cart[cartItem] * productInfo.price / 100).toFixed(2).toString() + ' ' + productInfo.currency;
      }
    }
    rows.push(row);
  }
  return rows;
}

const OrdersCart = (props:PropsI) => {
  const { products, cart} = props;
  props.debug && console.log('OrderCart | {props}:', props);

  const handleDelete = (deleteItem:string) => {
    props.debug && console.log('handleDelete item:', deleteItem);
    const newCart = {};
    for (const item of Object.keys(cart)) {
      if (item !== deleteItem) newCart[item] = cart[item];
    }
    props.updateCart(newCart);
  }

  // empty carts
  if (!Object.keys(cart).length) {
    return(
      <Contents>
        <EmptyCartContainer>
          <TextRegularItalics>No Items in Cart</TextRegularItalics>
        </EmptyCartContainer>
      </Contents>
    )
  }

  // cart with items
  return (
    <Contents>
      <OrdersCartTitle><IconCart/><Space/>Orders Cart</OrdersCartTitle>
      <BasicTable
        fields={tableFields}
        rows={getTableRows(cart, products, handleDelete)}
      />
    </Contents>
  );
};

OrdersCart.defaultProps = {
  debug: false
}

export default OrdersCart;

const Contents = styled.div`
  display: flex;
  width:  100%;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  font-size: ${(p) => p.theme.sizes.small};
`;

const EmptyCartContainer = styled.div`
  display: flex;
  padding: 10px;
  border-radius: 15px;
  border: 1px solid ${(p) => p.theme.palette.backgroundQuaternary};
`;

const Space = styled.div`
  display: flex;
  width: 10px;
`;

const OrdersCartTitle = styled.div`
  display: flex;
  font-size: 18px;
  margin-top: 12px;
`;
